"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSendFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M2.943 2.301c.592-.365 1.242-.398 1.951-.1l16.026 8.012c.72.447 1.08 1.043 1.08 1.79 0 .747-.36 1.343-1.08 1.79L4.894 21.801c-.706.297-1.356.262-1.95-.105-.595-.368-.91-.93-.944-1.685v-5.01l7.268-2.908a.1.1 0 000-.186L2 9V3.991c.038-.76.352-1.324.943-1.69z' }))); };
exports.default = SvgSendFilled;
//# sourceMappingURL=SendFilled.js.map